<template>
  <div v-if="false">
    Dostawy oczekujące:
    <template v-for="(item) in shipments">
      <div @click="mthLoadShipment(item.dataDostawy)" class="shipment" :key="item.dataDostawy">{{item.dataDostawy}} ({{item.liczbaProduktow}})</div>
    </template>
  </div>
</template>

<script>
import { mdbIcon } from "mdbvue";
import { mdbBtn } from "mdbvue";

export default {
  name: "Shipments",
  data() {
    return {
      chosenShipment: "",
      shipments: []
    };
  },
  created() {
    this.mthGetShipments();
  },
  methods: {
    mthLoadShipment(dataDostawy){
      console.log('will load shipment '+dataDostawy);
      this.chosenShipment = dataDostawy;
      this.$emit("shipments-set",dataDostawy);
    },
    mthGetShipments() {
      this.loading = true;
      var apiurl = this.$config.API_URL + "/shipments";
      var that = this;

      this.$axios({
        method: "get",
        url: apiurl
      })
        .then(function(response) {
          console.log("shipments:");
          console.log(response.data);
          that.shipments = response.data;
        })
        .catch(function(error) {
          console.log(error);
          //that.msg = "Brak połączenia z API (" + error + ").";
        });
    }
  },
  components: {
    mdbBtn,
    mdbIcon
  }
};
</script>

<style scoped>
.shipment {
  padding-right: 24px;
  font-size: 14pt;
  font-weight: bold;
  color: blue;
  display: inline;
}
</style>
